let usbKeyErrZh = {
    100: {
        descArgs: '数据格式错误。',
        reasonArgs: '数据格式错误。',
        detailArgs: '数据格式错误。',
        adviceArgs: '请检查参数。',
    },
    152: {
        descArgs: '指定的PIN已经过期。',
        reasonArgs: '指定的PIN已经过期。',
        detailArgs: '指定的PIN已经过期。',
        adviceArgs: '',
    },
    153: {
        descArgs: '指定的令牌不支持并行会话。',
        reasonArgs: '指定的令牌不支持并行会话。',
        detailArgs: '指定的令牌不支持并行会话。',
        adviceArgs: '',
    },
    500: {
        descArgs: '业务处理中。',
        reasonArgs: '业务处理中。',
        detailArgs: '业务处理中。',
        adviceArgs: '请稍候再试。',
    },
    3489660928: {
        descArgs: '服务请求超时。',
        reasonArgs: '服务请求超时。',
        detailArgs: '服务请求超时。',
        adviceArgs: '请检查网络或检查驱动是否安装。',
    },
    3489660929: {
        descArgs: '连接USB KEY失败。请确认是否已安装制证工具。',
        reasonArgs: '连接USB KEY失败。请确认是否已安装制证工具。',
        detailArgs: '连接USB KEY失败。请确认是否已安装制证工具。',
        adviceArgs: '请检查网络或检查驱动是否安装。',
    },
    3489660930: {
        descArgs: 'HTTPS请求失败。',
        reasonArgs: 'HTTPS请求失败。',
        detailArgs: 'HTTPS请求失败。',
        adviceArgs: '请检查参数是否正常。',
    },
    3489660931: {
        descArgs: 'HTTPS返回值异常。',
        reasonArgs: 'HTTPS返回值异常。',
        detailArgs: 'HTTPS返回值异常。',
        adviceArgs: '请检查参数是否正常。',
    },
    3758096385: { descArgs: '操作失败。', reasonArgs: '操作失败。', detailArgs: '操作失败。', adviceArgs: '' },
    3758096386: {
        descArgs: '用户取消操作。',
        reasonArgs: '用户取消操作。',
        detailArgs: '用户取消操作。',
        adviceArgs: '',
    },
    3758096387: { descArgs: '无效的参数。', reasonArgs: '无效的参数。', detailArgs: '无效的参数。', adviceArgs: '' },
    3758096388: {
        descArgs: 'BUFFER空间不足。',
        reasonArgs: 'BUFFER空间不足。',
        detailArgs: 'BUFFER空间不足。',
        adviceArgs: '',
    },
    3758096389: {
        descArgs: '没有足够的内存来执行请求的函数。',
        reasonArgs: '没有足够的内存来执行请求的函数。',
        detailArgs: '没有足够的内存来执行请求的函数。',
        adviceArgs: '',
    },
    3758096390: { descArgs: '没有初始化。', reasonArgs: '没有初始化。', detailArgs: '没有初始化。', adviceArgs: '' },
    3758096391: { descArgs: '函数已废弃。', reasonArgs: '函数已废弃。', detailArgs: '函数已废弃。', adviceArgs: '' },
    3758096392: { descArgs: '函数不支持。', reasonArgs: '函数不支持。', detailArgs: '函数不支持。', adviceArgs: '' },
    3758096393: {
        descArgs: '函数不支持并行操作。',
        reasonArgs: '函数不支持并行操作。',
        detailArgs: '函数不支持并行操作。',
        adviceArgs: '',
    },
    3758096394: {
        descArgs: '访问函数被拒绝。',
        reasonArgs: '访问函数被拒绝。',
        detailArgs: '访问函数被拒绝。',
        adviceArgs: '',
    },
    3758096395: { descArgs: '无效句柄。', reasonArgs: '无效句柄。', detailArgs: '无效句柄。', adviceArgs: '' },
    3758096396: {
        descArgs: '创建对象失败。',
        reasonArgs: '创建对象失败。',
        detailArgs: '创建对象失败。',
        adviceArgs: '',
    },
    3758096397: { descArgs: '对象无效。', reasonArgs: '对象无效。', detailArgs: '对象无效。', adviceArgs: '' },
    3758096398: { descArgs: '对象未找到。', reasonArgs: '对象未找到。', detailArgs: '对象未找到。', adviceArgs: '' },
    3758096399: {
        descArgs: '文件不存在或未验证口令。',
        reasonArgs: '文件不存在或未验证口令。',
        detailArgs: '文件不存在或未验证口令。',
        adviceArgs: '',
    },
    3758096400: { descArgs: '文件已存在。', reasonArgs: '文件已存在。', detailArgs: '文件已存在。', adviceArgs: '' },
    3758096401: {
        descArgs: '文件操作失败。',
        reasonArgs: '文件操作失败。',
        detailArgs: '文件操作失败。',
        adviceArgs: '',
    },
    3758096402: { descArgs: '文件读失败。', reasonArgs: '文件读失败。', detailArgs: '文件读失败。', adviceArgs: '' },
    3758096403: { descArgs: '文件写失败。', reasonArgs: '文件写失败。', detailArgs: '文件写失败。', adviceArgs: '' },
    3758096404: {
        descArgs: '加载DLL库失败。',
        reasonArgs: '加载DLL库失败。',
        detailArgs: '加载DLL库失败。',
        adviceArgs: '',
    },
    3758096405: {
        descArgs: '获取函数句柄失败。',
        reasonArgs: '获取函数句柄失败。',
        detailArgs: '获取函数句柄失败。',
        adviceArgs: '',
    },
    3758096406: { descArgs: '服务超时。', reasonArgs: '服务超时。', detailArgs: '服务超时。', adviceArgs: '' },
    3758096407: {
        descArgs: '说明提供保存的密码操作状态无效，因此不能在指定的对话中恢复。',
        reasonArgs: '说明提供保存的密码操作状态无效，因此不能在指定的对话中恢复。',
        detailArgs: '说明提供保存的密码操作状态无效，因此不能在指定的对话中恢复。',
        adviceArgs: '',
    },
    3758096408: {
        descArgs: '由于令牌认为请求的信息敏感或不愿意显示，因而不能获得请求的信息。',
        reasonArgs: '由于令牌认为请求的信息敏感或不愿意显示，因而不能获得请求的信息。',
        detailArgs: '由于令牌认为请求的信息敏感或不愿意显示，因而不能获得请求的信息。',
        adviceArgs: '',
    },
    3758096409: {
        descArgs: '由于某种原因（可能只是令牌不能保存当前的状态），不能保存指定对话的密码操作状态。',
        reasonArgs: '由于某种原因（可能只是令牌不能保存当前的状态），不能保存指定对话的密码操作状态。',
        detailArgs: '由于某种原因（可能只是令牌不能保存当前的状态），不能保存指定对话的密码操作状态。',
        adviceArgs: '',
    },
    3758096410: {
        descArgs: '由于Cryptoki 库尚未通过调用C_Initialize 而初始化因而函数不能执行。',
        reasonArgs: '由于Cryptoki 库尚未通过调用C_Initialize 而初始化因而函数不能执行。',
        detailArgs: '由于Cryptoki 库尚未通过调用C_Initialize 而初始化因而函数不能执行。',
        adviceArgs: '',
    },
    3758096411: {
        descArgs: 'Cryptoki库已经初始化。',
        reasonArgs: 'Cryptoki库已经初始化。',
        detailArgs: 'Cryptoki库已经初始化。',
        adviceArgs: '',
    },
    3758096412: {
        descArgs: '一个坏的mutex对象。',
        reasonArgs: '一个坏的mutex对象。',
        detailArgs: '一个坏的mutex对象。',
        adviceArgs: '',
    },
    3758096413: {
        descArgs: 'mutex对象未锁定。',
        reasonArgs: 'mutex对象未锁定。',
        detailArgs: 'mutex对象未锁定。',
        adviceArgs: '',
    },
    3758096414: {
        descArgs: '指定的密钥不是配合指定的机制使用的正确类型的密钥。',
        reasonArgs: '指定的密钥不是配合指定的机制使用的正确类型的密钥。',
        detailArgs: '指定的密钥不是配合指定的机制使用的正确类型的密钥。',
        adviceArgs: '',
    },
    3758096415: {
        descArgs:
            '给C_SetOperationState 提供一个附加的密钥。比如说，尝试恢复一个正在执行消息摘要操作的对话，提供一个加密密钥。',
        reasonArgs:
            '给C_SetOperationState 提供一个附加的密钥。比如说，尝试恢复一个正在执行消息摘要操作的对话，提供一个加密密钥。',
        detailArgs:
            '给C_SetOperationState 提供一个附加的密钥。比如说，尝试恢复一个正在执行消息摘要操作的对话，提供一个加密密钥。',
        adviceArgs: '',
    },
    3758096416: {
        descArgs: '指定的某个密钥并不是原来保存的对话中使用的同一密钥。',
        reasonArgs: '指定的某个密钥并不是原来保存的对话中使用的同一密钥。',
        detailArgs: '指定的某个密钥并不是原来保存的对话中使用的同一密钥。',
        adviceArgs: '',
    },
    3758096417: {
        descArgs:
            '它表明由于需要给C_SetOperationState提供一个或多个原来保存的对话中使用的密钥，因而对话的状态不能恢复。',
        reasonArgs:
            '它表明由于需要给C_SetOperationState提供一个或多个原来保存的对话中使用的密钥，因而对话的状态不能恢复。',
        detailArgs:
            '它表明由于需要给C_SetOperationState提供一个或多个原来保存的对话中使用的密钥，因而对话的状态不能恢复。',
        adviceArgs: '',
    },
    3758096418: {
        descArgs: '指定的密钥的值由于某种原因而不能被摘要。',
        reasonArgs: '指定的密钥的值由于某种原因而不能被摘要。',
        detailArgs: '指定的密钥的值由于某种原因而不能被摘要。',
        adviceArgs: '',
    },
    3758096419: {
        descArgs: '尝试使用密钥达到密钥的属性没有设置成允许的加密目的。',
        reasonArgs: '尝试使用密钥达到密钥的属性没有设置成允许的加密目的。',
        detailArgs: '尝试使用密钥达到密钥的属性没有设置成允许的加密目的。',
        adviceArgs: '',
    },
    3758096420: {
        descArgs:
            '尽管指定的私有或保密密钥并没有将自己的CKA_UNEXTRACTABLE 属性设置成TRUE，但Cryptoki （或令牌）不能应请求打包密钥（可能令牌只能打包带有特定类型密钥的给定密钥，而指定的打包密钥却不是这些类型之一）。与CKR_KEY_UNEXTRACTABLE 做比较。',
        reasonArgs:
            '尽管指定的私有或保密密钥并没有将自己的CKA_UNEXTRACTABLE 属性设置成TRUE，但Cryptoki （或令牌）不能应请求打包密钥（可能令牌只能打包带有特定类型密钥的给定密钥，而指定的打包密钥却不是这些类型之一）。与CKR_KEY_UNEXTRACTABLE 做比较。',
        detailArgs:
            '尽管指定的私有或保密密钥并没有将自己的CKA_UNEXTRACTABLE 属性设置成TRUE，但Cryptoki （或令牌）不能应请求打包密钥（可能令牌只能打包带有特定类型密钥的给定密钥，而指定的打包密钥却不是这些类型之一）。与CKR_KEY_UNEXTRACTABLE 做比较。',
        adviceArgs: '',
    },
    3758096421: {
        descArgs: '由于其CKA_UNEXTRACTABLE属性被设置为TRUE，因而指定的私有或保密密钥不能被打包。',
        reasonArgs: '由于其CKA_UNEXTRACTABLE属性被设置为TRUE，因而指定的私有或保密密钥不能被打包。',
        detailArgs: '由于其CKA_UNEXTRACTABLE属性被设置为TRUE，因而指定的私有或保密密钥不能被打包。',
        adviceArgs: '',
    },
    3758096422: {
        descArgs: '密钥用途错误。',
        reasonArgs: '密钥用途错误。',
        detailArgs: '密钥用途错误。',
        adviceArgs: '',
    },
    3758096423: {
        descArgs: '指定的密钥句柄无效。',
        reasonArgs: '指定的密钥句柄无效。',
        detailArgs: '指定的密钥句柄无效。',
        adviceArgs: '',
    },
    3758096424: {
        descArgs: '提供的密钥的尺寸超出了它能管理的密钥尺寸的范围。',
        reasonArgs: '提供的密钥的尺寸超出了它能管理的密钥尺寸的范围。',
        detailArgs: '提供的密钥的尺寸超出了它能管理的密钥尺寸的范围。',
        adviceArgs: '',
    },
    3758096425: {
        descArgs: '给密码操作指定一个无效的机制。',
        reasonArgs: '给密码操作指定一个无效的机制。',
        detailArgs: '给密码操作指定一个无效的机制。',
        adviceArgs: '',
    },
    3758096426: {
        descArgs: '给为密码操作指定的机制提供无效的参数。',
        reasonArgs: '给为密码操作指定的机制提供无效的参数。',
        detailArgs: '给为密码操作指定的机制提供无效的参数。',
        adviceArgs: '',
    },
    3758096427: {
        descArgs: '密钥类型错误。',
        reasonArgs: '密钥类型错误。',
        detailArgs: '密钥类型错误。',
        adviceArgs: '',
    },
    3758096428: { descArgs: '密钥未发现。', reasonArgs: '密钥未发现。', detailArgs: '密钥未发现。', adviceArgs: '' },
    3758096429: {
        descArgs: '说明提供的打包密钥无效。',
        reasonArgs: '说明提供的打包密钥无效。',
        detailArgs: '说明提供的打包密钥无效。',
        adviceArgs: '',
    },
    3758096430: {
        descArgs: '说明只根据密钥的长度就能将打包密钥看成是无效的。',
        reasonArgs: '说明只根据密钥的长度就能将打包密钥看成是无效的。',
        detailArgs: '说明只根据密钥的长度就能将打包密钥看成是无效的。',
        adviceArgs: '',
    },
    3758096431: {
        descArgs: '说明用来打包另一个密钥的密钥句柄无效。',
        reasonArgs: '说明用来打包另一个密钥的密钥句柄无效。',
        detailArgs: '说明用来打包另一个密钥的密钥句柄无效。',
        adviceArgs: '',
    },
    3758096432: {
        descArgs:
            '说明理论上可以执行请求的打包操作，但实际上该Cryptoki 库（或令牌）不能进行，这是因为提供的打包密钥的尺寸超出了它能处理的密钥的尺寸的范围。',
        reasonArgs:
            '说明理论上可以执行请求的打包操作，但实际上该Cryptoki 库（或令牌）不能进行，这是因为提供的打包密钥的尺寸超出了它能处理的密钥的尺寸的范围。',
        detailArgs:
            '说明理论上可以执行请求的打包操作，但实际上该Cryptoki 库（或令牌）不能进行，这是因为提供的打包密钥的尺寸超出了它能处理的密钥的尺寸的范围。',
        adviceArgs: '',
    },
    3758096433: {
        descArgs: '说明指定打包另一密钥的密钥类型与指定打包的机制不一致。',
        reasonArgs: '说明指定打包另一密钥的密钥类型与指定打包的机制不一致。',
        detailArgs: '说明指定打包另一密钥的密钥类型与指定打包的机制不一致。',
        adviceArgs: '',
    },
    3758096434: {
        descArgs: '说明指定用于解包另一个密钥的密钥句柄无效。',
        reasonArgs: '说明指定用于解包另一个密钥的密钥句柄无效。',
        detailArgs: '说明指定用于解包另一个密钥的密钥句柄无效。',
        adviceArgs: '',
    },
    3758096435: {
        descArgs:
            '说明尽管理论上不能执行请求的解包操作，但该Cryptoki库（或令牌）实际上不能执行，因为密钥的尺寸超出了它能处理的密钥尺寸的范围。',
        reasonArgs:
            '说明尽管理论上不能执行请求的解包操作，但该Cryptoki库（或令牌）实际上不能执行，因为密钥的尺寸超出了它能处理的密钥尺寸的范围。',
        detailArgs:
            '说明尽管理论上不能执行请求的解包操作，但该Cryptoki库（或令牌）实际上不能执行，因为密钥的尺寸超出了它能处理的密钥尺寸的范围。',
        adviceArgs: '',
    },
    3758096436: {
        descArgs: '说明指定来解包另一个密钥的密钥类型与指定于解包的机制不一致。',
        reasonArgs: '说明指定来解包另一个密钥的密钥类型与指定于解包的机制不一致。',
        detailArgs: '说明指定来解包另一个密钥的密钥类型与指定于解包的机制不一致。',
        adviceArgs: '',
    },
    3758096437: {
        descArgs: '已经有一个现用的操作（或现用操作的组合）防止Cryptoki 激活指定的操作。',
        reasonArgs: '已经有一个现用的操作（或现用操作的组合）防止Cryptoki 激活指定的操作。',
        detailArgs: '已经有一个现用的操作（或现用操作的组合）防止Cryptoki 激活指定的操作。',
        adviceArgs: '',
    },
    3758096438: {
        descArgs: '指定的对话中没有适当类型的现用操作。',
        reasonArgs: '指定的对话中没有适当类型的现用操作。',
        detailArgs: '指定的对话中没有适当类型的现用操作。',
        adviceArgs: '',
    },
    3758096439: { descArgs: '名称长度错。', reasonArgs: '名称长度错。', detailArgs: '名称长度错。', adviceArgs: '' },
    3758096440: {
        descArgs: 'module长度错。',
        reasonArgs: 'module长度错。',
        detailArgs: 'module长度错。',
        adviceArgs: '',
    },
    3758096441: {
        descArgs: '输入参数错误。',
        reasonArgs: '输入参数错误。',
        detailArgs: '输入参数错误。',
        adviceArgs: '',
    },
    3758096442: {
        descArgs: '输入参数长度错误。',
        reasonArgs: '输入参数长度错误。',
        detailArgs: '输入参数长度错误。',
        adviceArgs: '',
    },
    3758096443: {
        descArgs: '生成随机数失败。',
        reasonArgs: '生成随机数失败。',
        detailArgs: '生成随机数失败。',
        adviceArgs: '',
    },
    3758096444: {
        descArgs: '说明令牌的随机数字产生器不接收应用的SEED。',
        reasonArgs: '说明令牌的随机数字产生器不接收应用的SEED。',
        detailArgs: '说明令牌的随机数字产生器不接收应用的SEED。',
        adviceArgs: '',
    },
    3758096445: {
        descArgs: '表明指定的令牌没有随机数字产生器。',
        reasonArgs: '表明指定的令牌没有随机数字产生器。',
        detailArgs: '表明指定的令牌没有随机数字产生器。',
        adviceArgs: '',
    },
    3758096446: {
        descArgs:
            '表示发生了某些可怕的、无法挽回的错误。最坏的情况下，函数有可能会部分地获得成功，计算机和/或令牌处于不相容的状态。',
        reasonArgs:
            '表示发生了某些可怕的、无法挽回的错误。最坏的情况下，函数有可能会部分地获得成功，计算机和/或令牌处于不相容的状态。',
        detailArgs:
            '表示发生了某些可怕的、无法挽回的错误。最坏的情况下，函数有可能会部分地获得成功，计算机和/或令牌处于不相容的状态。',
        adviceArgs: '',
    },
    3758096447: {
        descArgs: '指定的槽ID无效。',
        reasonArgs: '指定的槽ID无效。',
        detailArgs: '指定的槽ID无效。',
        adviceArgs: '',
    },
    3758096448: {
        descArgs: '因令牌和/或槽而出现某个问题。',
        reasonArgs: '因令牌和/或槽而出现某个问题。',
        detailArgs: '因令牌和/或槽而出现某个问题。',
        adviceArgs: '',
    },
    3758096449: {
        descArgs: '令牌无足够的内存来执行请求的函数。',
        reasonArgs: '令牌无足够的内存来执行请求的函数。',
        detailArgs: '令牌无足够的内存来执行请求的函数。',
        adviceArgs: '',
    },
    3758096450: {
        descArgs: '在函数执行过程中，该令牌被从槽中删除。',
        reasonArgs: '在函数执行过程中，该令牌被从槽中删除。',
        detailArgs: '在函数执行过程中，该令牌被从槽中删除。',
        adviceArgs: '',
    },
    3758096451: {
        descArgs: '该函数被调用时，令牌不在槽中。',
        reasonArgs: '该函数被调用时，令牌不在槽中。',
        detailArgs: '该函数被调用时，令牌不在槽中。',
        adviceArgs: '',
    },
    3758096452: {
        descArgs: 'Cryptoki库和/或槽不能识别槽中的令牌。',
        reasonArgs: 'Cryptoki库和/或槽不能识别槽中的令牌。',
        detailArgs: 'Cryptoki库和/或槽不能识别槽中的令牌。',
        adviceArgs: '',
    },
    3758096453: {
        descArgs: '由于令牌有写保护，因而不能执行请求的动作。',
        reasonArgs: '由于令牌有写保护，因而不能执行请求的动作。',
        detailArgs: '由于令牌有写保护，因而不能执行请求的动作。',
        adviceArgs: '',
    },
    3758096454: {
        descArgs: 'room空间不足。',
        reasonArgs: 'room空间不足。',
        detailArgs: 'room空间不足。',
        adviceArgs: '',
    },
    3758096455: {
        descArgs: '达到最大的容器数。',
        reasonArgs: '达到最大的容器数。',
        detailArgs: '达到最大的容器数。',
        adviceArgs: '',
    },
    3758096456: {
        descArgs: '当以无阻塞模式调用C_GetSlotEvent 而且没有新的槽事件返回时就返回该值。',
        reasonArgs: '当以无阻塞模式调用C_GetSlotEvent 而且没有新的槽事件返回时就返回该值。',
        detailArgs: '当以无阻塞模式调用C_GetSlotEvent 而且没有新的槽事件返回时就返回该值。',
        adviceArgs: '',
    },
    3758096457: {
        descArgs: '库不能产生新的线程就不能正常地执行其功能。',
        reasonArgs: '库不能产生新的线程就不能正常地执行其功能。',
        detailArgs: '库不能产生新的线程就不能正常地执行其功能。',
        adviceArgs: '',
    },
    3758096458: {
        descArgs: '这意味着应用因为线程安全而请求的这种类型的锁定在该库中得不到，因此该应用不能以指定的方式使用该库。',
        reasonArgs:
            '这意味着应用因为线程安全而请求的这种类型的锁定在该库中得不到，因此该应用不能以指定的方式使用该库。',
        detailArgs:
            '这意味着应用因为线程安全而请求的这种类型的锁定在该库中得不到，因此该应用不能以指定的方式使用该库。',
        adviceArgs: '',
    },
    3758096459: {
        descArgs: '函数执行过程中，关闭该对话。',
        reasonArgs: '函数执行过程中，关闭该对话。',
        detailArgs: '函数执行过程中，关闭该对话。',
        adviceArgs: '',
    },
    3758096460: {
        descArgs: '说明或者是因为令牌有太多的对话已打开，或者因为令牌有太多的读/写对话已打开，所以尝试打开对话失败。',
        reasonArgs: '说明或者是因为令牌有太多的对话已打开，或者因为令牌有太多的读/写对话已打开，所以尝试打开对话失败。',
        detailArgs: '说明或者是因为令牌有太多的对话已打开，或者因为令牌有太多的读/写对话已打开，所以尝试打开对话失败。',
        adviceArgs: '',
    },
    3758096461: {
        descArgs: '当函数被调用时，指定的对话句柄无效。',
        reasonArgs: '当函数被调用时，指定的对话句柄无效。',
        detailArgs: '当函数被调用时，指定的对话句柄无效。',
        adviceArgs: '',
    },
    3758096462: {
        descArgs: '指定的对话不能获得想要的执行动作，因为它是一个只读对话。',
        reasonArgs: '指定的对话不能获得想要的执行动作，因为它是一个只读对话。',
        detailArgs: '指定的对话不能获得想要的执行动作，因为它是一个只读对话。',
        adviceArgs: '',
    },
    3758096463: {
        descArgs: '说明有令牌的对话已打开，因此令牌不能初始化。',
        reasonArgs: '说明有令牌的对话已打开，因此令牌不能初始化。',
        detailArgs: '说明有令牌的对话已打开，因此令牌不能初始化。',
        adviceArgs: '',
    },
    3758096464: {
        descArgs: '只读对话已经存在，因此不能注册SO。',
        reasonArgs: '只读对话已经存在，因此不能注册SO。',
        detailArgs: '只读对话已经存在，因此不能注册SO。',
        adviceArgs: '',
    },
    3758096465: {
        descArgs: '读/写SO对话已经存在，因此不能打开只读对话。',
        reasonArgs: '读/写SO对话已经存在，因此不能打开只读对话。',
        detailArgs: '读/写SO对话已经存在，因此不能打开只读对话。',
        adviceArgs: '',
    },
    3758096466: {
        descArgs: '指定的令牌不支持并行对话。',
        reasonArgs: '指定的令牌不支持并行对话。',
        detailArgs: '指定的令牌不支持并行对话。',
        adviceArgs: '',
    },
    3758096467: {
        descArgs: '应用名称无效。',
        reasonArgs: '应用名称无效。',
        detailArgs: '应用名称无效。',
        adviceArgs: '',
    },
    3758096468: { descArgs: '应用已存在。', reasonArgs: '应用已存在。', detailArgs: '应用已存在。', adviceArgs: '' },
    3758096469: { descArgs: '应用不存在。', reasonArgs: '应用不存在。', detailArgs: '应用不存在。', adviceArgs: '' },
    3758096470: {
        descArgs: '指定的PIN不正确。',
        reasonArgs: '指定的PIN不正确。',
        detailArgs: '指定的PIN不正确。',
        adviceArgs: '',
    },
    3758096471: {
        descArgs: '指定的PIN被“锁定”，不能使用。',
        reasonArgs: '指定的PIN被“锁定”，不能使用。',
        detailArgs: '指定的PIN被“锁定”，不能使用。',
        adviceArgs: '',
    },
    3758096472: {
        descArgs: '指定的PIN中含有无效的字符。',
        reasonArgs: '指定的PIN中含有无效的字符。',
        detailArgs: '指定的PIN中含有无效的字符。',
        adviceArgs: '',
    },
    3758096473: {
        descArgs: '指定的PIN太长或太短。',
        reasonArgs: '指定的PIN太长或太短。',
        detailArgs: '指定的PIN太长或太短。',
        adviceArgs: '',
    },
    3758096474: {
        descArgs: '因为恰当的用户（或一个恰当的用户）没有注册，因而不能执行想要的动作。',
        reasonArgs: '因为恰当的用户（或一个恰当的用户）没有注册，因而不能执行想要的动作。',
        detailArgs: '因为恰当的用户（或一个恰当的用户）没有注册，因而不能执行想要的动作。',
        adviceArgs: '',
    },
    3758096475: {
        descArgs: '指定的用户不能注册进入对话，因为它已经注册进对话了。',
        reasonArgs: '指定的用户不能注册进入对话，因为它已经注册进对话了。',
        detailArgs: '指定的用户不能注册进入对话，因为它已经注册进对话了。',
        adviceArgs: '',
    },
    3758096476: {
        descArgs: '其他用户已经注册进对话了，因而指定的用户不能注册进对话。',
        reasonArgs: '其他用户已经注册进对话了，因而指定的用户不能注册进对话。',
        detailArgs: '其他用户已经注册进对话了，因而指定的用户不能注册进对话。',
        adviceArgs: '',
    },
    3758096477: {
        descArgs: '说明尚不能用C_InitPIN来初始化普通用户的PIN。',
        reasonArgs: '说明尚不能用C_InitPIN来初始化普通用户的PIN。',
        detailArgs: '说明尚不能用C_InitPIN来初始化普通用户的PIN。',
        adviceArgs: '',
    },
    3758096478: {
        descArgs:
            '指定的PIN已到期，请求的操作不能执行，除非调用 C_SetPIN 来改变PIN的值。令牌上普通用户的PIN是否到期因令牌而异。',
        reasonArgs:
            '指定的PIN已到期，请求的操作不能执行，除非调用 C_SetPIN 来改变PIN的值。令牌上普通用户的PIN是否到期因令牌而异。',
        detailArgs:
            '指定的PIN已到期，请求的操作不能执行，除非调用 C_SetPIN 来改变PIN的值。令牌上普通用户的PIN是否到期因令牌而异。',
        adviceArgs: '',
    },
    3758096479: {
        descArgs: '将一个无效值指定成CK_USER_TYPE 。',
        reasonArgs: '将一个无效值指定成CK_USER_TYPE 。',
        detailArgs: '将一个无效值指定成CK_USER_TYPE 。',
        adviceArgs: '',
    },
    3758096480: {
        descArgs: '尝试同时在令牌中注册超过令牌和/或库所允许的更多的不同用户。',
        reasonArgs: '尝试同时在令牌中注册超过令牌和/或库所允许的更多的不同用户。',
        detailArgs: '尝试同时在令牌中注册超过令牌和/或库所允许的更多的不同用户。',
        adviceArgs: '',
    },
    3758096481: { descArgs: '证书未发现。', reasonArgs: '证书未发现。', detailArgs: '证书未发现。', adviceArgs: '' },
    3758096482: { descArgs: '对象未导出。', reasonArgs: '对象未导出。', detailArgs: '对象未导出。', adviceArgs: '' },
    3758096483: { descArgs: 'MAC长度错误。', reasonArgs: 'MAC长度错误。', detailArgs: 'MAC长度错误。', adviceArgs: '' },
    3758096484: {
        descArgs: 'DOMAIN参数错误。',
        reasonArgs: 'DOMAIN参数错误。',
        detailArgs: 'DOMAIN参数错误。',
        adviceArgs: '',
    },
    3758096485: {
        descArgs: '摘要对象有误。',
        reasonArgs: '摘要对象有误。',
        detailArgs: '摘要对象有误。',
        adviceArgs: '',
    },
    3758096486: {
        descArgs: 'HASH运算错误。',
        reasonArgs: 'HASH运算错误。',
        detailArgs: 'HASH运算错误。',
        adviceArgs: '',
    },
    3758096487: {
        descArgs: 'HASH值不相等。',
        reasonArgs: 'HASH值不相等。',
        detailArgs: 'HASH值不相等。',
        adviceArgs: '',
    },
    3758096488: {
        descArgs: '生成RSA密钥失败。',
        reasonArgs: '生成RSA密钥失败。',
        detailArgs: '生成RSA密钥失败。',
        adviceArgs: '',
    },
    3758096489: {
        descArgs: 'RSA密钥模长错误。',
        reasonArgs: 'RSA密钥模长错误。',
        detailArgs: 'RSA密钥模长错误。',
        adviceArgs: '',
    },
    3758096490: {
        descArgs: 'CSP服务导入公钥错误。',
        reasonArgs: 'CSP服务导入公钥错误。',
        detailArgs: 'CSP服务导入公钥错误。',
        adviceArgs: '',
    },
    3758096491: { descArgs: 'RSA加密失败。', reasonArgs: 'RSA加密失败。', detailArgs: 'RSA加密失败。', adviceArgs: '' },
    3758096492: { descArgs: 'RSA解密失败。', reasonArgs: 'RSA解密失败。', detailArgs: 'RSA解密失败。', adviceArgs: '' },
    3758096493: {
        descArgs: '加密数据无效。',
        reasonArgs: '加密数据无效。',
        detailArgs: '加密数据无效。',
        adviceArgs: '',
    },
    3758096494: {
        descArgs: '加密数据长度无效。',
        reasonArgs: '加密数据长度无效。',
        detailArgs: '加密数据长度无效。',
        adviceArgs: '',
    },
    3758096495: {
        descArgs: '解密时做补丁错误。',
        reasonArgs: '解密时做补丁错误。',
        detailArgs: '解密时做补丁错误。',
        adviceArgs: '',
    },
    3758096496: {
        descArgs: '提供的签名/MAC无效。',
        reasonArgs: '提供的签名/MAC无效。',
        detailArgs: '提供的签名/MAC无效。',
        adviceArgs: '',
    },
    3758096497: {
        descArgs: '签名长度无效。',
        reasonArgs: '签名长度无效。',
        detailArgs: '签名长度无效。',
        adviceArgs: '',
    },
    3758096498: {
        descArgs: '为创建一个对象而指定的模板不完整，缺少某些必要的属性。',
        reasonArgs: '为创建一个对象而指定的模板不完整，缺少某些必要的属性。',
        detailArgs: '为创建一个对象而指定的模板不完整，缺少某些必要的属性。',
        adviceArgs: '',
    },
    3758096499: {
        descArgs: '为创建一个对象而指定的模板有相矛盾的属性。',
        reasonArgs: '为创建一个对象而指定的模板有相矛盾的属性。',
        detailArgs: '为创建一个对象而指定的模板有相矛盾的属性。',
        adviceArgs: '',
    },
    3758096500: {
        descArgs: '试图为可能未被设置或修改的一个属性设定一个值。',
        reasonArgs: '试图为可能未被设置或修改的一个属性设定一个值。',
        detailArgs: '试图为可能未被设置或修改的一个属性设定一个值。',
        adviceArgs: '',
    },
    3758096501: {
        descArgs: '试图获得一个对象的属性值，该对象因其敏感性或不可抽取性而不能满意。 。',
        reasonArgs: '试图获得一个对象的属性值，该对象因其敏感性或不可抽取性而不能满意。 。',
        detailArgs: '试图获得一个对象的属性值，该对象因其敏感性或不可抽取性而不能满意。 。',
        adviceArgs: '',
    },
    3758096502: {
        descArgs: '模板中指定的一种无效属性。',
        reasonArgs: '模板中指定的一种无效属性。',
        detailArgs: '模板中指定的一种无效属性。',
        adviceArgs: '',
    },
    3758096503: {
        descArgs: '为模板中的一个属性指定指定无效值。',
        reasonArgs: '为模板中的一个属性指定指定无效值。',
        detailArgs: '为模板中的一个属性指定指定无效值。',
        adviceArgs: '',
    },
    3758096504: {
        descArgs: '没有选择证书。',
        reasonArgs: '没有选择证书。',
        detailArgs: '没有选择证书。',
        adviceArgs: '',
    },
    3758096505: {
        descArgs: '证书无效(证书过期或未生效)。',
        reasonArgs: '证书无效(证书过期或未生效)。',
        detailArgs: '证书无效(证书过期或未生效)。',
        adviceArgs: '',
    },
    3758096506: {
        descArgs: 'PFX验证PASSWORD失败。',
        reasonArgs: 'PFX验证PASSWORD失败。',
        detailArgs: 'PFX验证PASSWORD失败。',
        adviceArgs: '',
    },
    3758096507: {
        descArgs: '证书是公钥证书。',
        reasonArgs: '证书是公钥证书。',
        detailArgs: '证书是公钥证书。',
        adviceArgs: '',
    },
    3758096508: { descArgs: '对象已存在。', reasonArgs: '对象已存在。', detailArgs: '对象已存在。', adviceArgs: '' },
    3758096509: {
        descArgs: 'XML没有匹配的节点。',
        reasonArgs: 'XML没有匹配的节点。',
        detailArgs: 'XML没有匹配的节点。',
        adviceArgs: '',
    },
    3758096510: {
        descArgs: 'base64编码失败。',
        reasonArgs: 'base64编码失败。',
        detailArgs: 'base64编码失败。',
        adviceArgs: '',
    },
    3758096512: {
        descArgs: 'base64解码失败。',
        reasonArgs: 'base64解码失败。',
        detailArgs: 'base64解码失败。',
        adviceArgs: '',
    },
    3758096513: {
        descArgs: '获取版本错误。',
        reasonArgs: '获取版本错误。',
        detailArgs: '获取版本错误。',
        adviceArgs: '',
    },
    3758096514: {
        descArgs: '没有发现有效的接收者信息。',
        reasonArgs: '没有发现有效的接收者信息。',
        detailArgs: '没有发现有效的接收者信息。',
        adviceArgs: '',
    },
    3758096515: {
        descArgs: '数据长度不足。',
        reasonArgs: '数据长度不足。',
        detailArgs: '数据长度不足。',
        adviceArgs: '',
    },
    3758096516: {
        descArgs: '获取的数据还未准备好。',
        reasonArgs: '获取的数据还未准备好。',
        detailArgs: '获取的数据还未准备好。',
        adviceArgs: '',
    },
    3758096517: {
        descArgs: '没有发现可用的国密设备。',
        reasonArgs: '没有发现可用的国密设备。',
        detailArgs: '没有发现可用的国密设备。',
        adviceArgs: '',
    },
    3758096518: {
        descArgs: '没有发现可用的CSP设备。',
        reasonArgs: '没有发现可用的CSP设备。',
        detailArgs: '没有发现可用的CSP设备。',
        adviceArgs: '',
    },
    3758096519: {
        descArgs: '获取文件大小失败。',
        reasonArgs: '获取文件大小失败。',
        detailArgs: '获取文件大小失败。',
        adviceArgs: '',
    },
    3758096520: {
        descArgs: '文件内容为空。',
        reasonArgs: '文件内容为空。',
        detailArgs: '文件内容为空。',
        adviceArgs: '',
    },
    3758096521: {
        descArgs: '文件内容错误。',
        reasonArgs: '文件内容错误。',
        detailArgs: '文件内容错误。',
        adviceArgs: '',
    },
    3758096522: {
        descArgs: '不支持混合证书。',
        reasonArgs: '不支持混合证书。',
        detailArgs: '不支持混合证书。',
        adviceArgs: '',
    },
    3758096523: {
        descArgs: '不支持混合签名。',
        reasonArgs: '不支持混合签名。',
        detailArgs: '不支持混合签名。',
        adviceArgs: '',
    },
    3758096524: {
        descArgs: '不同的签名类型。',
        reasonArgs: '不同的签名类型。',
        detailArgs: '不同的签名类型。',
        adviceArgs: '',
    },
    3758096525: {
        descArgs: '签名结果原文不一致。',
        reasonArgs: '签名结果原文不一致。',
        detailArgs: '签名结果原文不一致。',
        adviceArgs: '',
    },
    3758096526: { descArgs: '解析XML失败。', reasonArgs: '解析XML失败。', detailArgs: '解析XML失败。', adviceArgs: '' },
    3758096527: { descArgs: '无效数据。', reasonArgs: '无效数据。', detailArgs: '无效数据。', adviceArgs: '' },
    3758096528: {
        descArgs: '指定的属性未找到。',
        reasonArgs: '指定的属性未找到。',
        detailArgs: '指定的属性未找到。',
        adviceArgs: '',
    },
    3758096529: {
        descArgs: '没有足够的存储器。',
        reasonArgs: '没有足够的存储器。',
        detailArgs: '没有足够的存储器。',
        adviceArgs: '',
    },
    3758096530: {
        descArgs: '无法执行所请求的功能，函数不支持。',
        reasonArgs: '无法执行所请求的功能，函数不支持。',
        detailArgs: '无法执行所请求的功能，函数不支持。',
        adviceArgs: '',
    },
    3758096531: { descArgs: '参数有错误。', reasonArgs: '参数有错误。', detailArgs: '参数有错误。', adviceArgs: '' },
    3758096532: {
        descArgs: '输入数据长度错误。',
        reasonArgs: '输入数据长度错误。',
        detailArgs: '输入数据长度错误。',
        adviceArgs: '',
    },
    3758096533: {
        descArgs: '该函数在执行过程中被取消。',
        reasonArgs: '该函数在执行过程中被取消。',
        detailArgs: '该函数在执行过程中被取消。',
        adviceArgs: '',
    },
    3758096534: { descArgs: '无效机制。', reasonArgs: '无效机制。', detailArgs: '无效机制。', adviceArgs: '' },
    3758096535: {
        descArgs: '机制的参数无效。',
        reasonArgs: '机制的参数无效。',
        detailArgs: '机制的参数无效。',
        adviceArgs: '',
    },
    3758096538: { descArgs: '没找到KEY。', reasonArgs: '没找到KEY。', detailArgs: '没找到KEY。', adviceArgs: '' },
    3758096539: { descArgs: 'KEY未初始化。', reasonArgs: 'KEY未初始化。', detailArgs: 'KEY未初始化。', adviceArgs: '' },
    3758096540: {
        descArgs: '插入的华大USBKey太多，超过4个 。',
        reasonArgs: '插入的华大USBKey太多，超过4个 。',
        detailArgs: '插入的华大USBKey太多，超过4个 。',
        adviceArgs: '',
    },
    3758096541: {
        descArgs: '读到的文件内容无效。',
        reasonArgs: '读到的文件内容无效。',
        detailArgs: '读到的文件内容无效。',
        adviceArgs: '',
    },
    3758096542: {
        descArgs: '调用fopen函数失败。',
        reasonArgs: '调用fopen函数失败。',
        detailArgs: '调用fopen函数失败。',
        adviceArgs: '',
    },
    3758096543: {
        descArgs: '初始化上下文失败。',
        reasonArgs: '初始化上下文失败。',
        detailArgs: '初始化上下文失败。',
        adviceArgs: '',
    },
    3758096544: {
        descArgs: '清除上下文失败。',
        reasonArgs: '清除上下文失败。',
        detailArgs: '清除上下文失败。',
        adviceArgs: '',
    },
    3758096545: {
        descArgs: '重装口令失败。',
        reasonArgs: '重装口令失败。',
        detailArgs: '重装口令失败。',
        adviceArgs: '',
    },
    3758096546: { descArgs: '功能不支持。', reasonArgs: '功能不支持。', detailArgs: '功能不支持。', adviceArgs: '' },
    3758096547: { descArgs: '填充失败。', reasonArgs: '填充失败。', detailArgs: '填充失败。', adviceArgs: '' },
    3758096548: { descArgs: '解填充失败。', reasonArgs: '解填充失败。', detailArgs: '解填充失败。', adviceArgs: '' },
    3758096549: {
        descArgs: '系统内存不足。',
        reasonArgs: '系统内存不足。',
        detailArgs: '系统内存不足。',
        adviceArgs: '',
    },
    3758096550: {
        descArgs: '输入参数错误。',
        reasonArgs: '输入参数错误。',
        detailArgs: '输入参数错误。',
        adviceArgs: '',
    },
    3758096551: { descArgs: 'DER编码错误。', reasonArgs: 'DER编码错误。', detailArgs: 'DER编码错误。', adviceArgs: '' },
    3758096552: {
        descArgs: 'DER反编码错误。',
        reasonArgs: 'DER反编码错误。',
        detailArgs: 'DER反编码错误。',
        adviceArgs: '',
    },
    3758096553: {
        descArgs: 'RSA公钥无效,可能是公钥结构或DER不正确。',
        reasonArgs: 'RSA公钥无效,可能是公钥结构或DER不正确。',
        detailArgs: 'RSA公钥无效,可能是公钥结构或DER不正确。',
        adviceArgs: '',
    },
    3758096554: {
        descArgs: 'RSA私钥无效,可能是私钥结构或DER不正确。',
        reasonArgs: 'RSA私钥无效,可能是私钥结构或DER不正确。',
        detailArgs: 'RSA私钥无效,可能是私钥结构或DER不正确。',
        adviceArgs: '',
    },
    3758096555: {
        descArgs: '分包标识错误\t。',
        reasonArgs: '分包标识错误\t。',
        detailArgs: '分包标识错误\t。',
        adviceArgs: '',
    },
    3758161921: {
        descArgs: '（管道）无效对象ID。',
        reasonArgs: '（管道）无效对象ID。',
        detailArgs: '（管道）无效对象ID。',
        adviceArgs: '',
    },
    3758161922: {
        descArgs: '（管道）读取头数据失败。',
        reasonArgs: '（管道）读取头数据失败。',
        detailArgs: '（管道）读取头数据失败。',
        adviceArgs: '',
    },
    3758161923: {
        descArgs: '（管道）消息扩展数据大小不对。',
        reasonArgs: '（管道）消息扩展数据大小不对。',
        detailArgs: '（管道）消息扩展数据大小不对。',
        adviceArgs: '',
    },
    3758161924: {
        descArgs: '（管道）连接错误。',
        reasonArgs: '（管道）连接错误。',
        detailArgs: '（管道）连接错误。',
        adviceArgs: '',
    },
    3758161925: {
        descArgs: '（管道）等待异步应答数据超时。',
        reasonArgs: '（管道）等待异步应答数据超时。',
        detailArgs: '（管道）等待异步应答数据超时。',
        adviceArgs: '',
    },
    3758161926: {
        descArgs: '（管道）发送应答机制，创建临时服务等待超时。',
        reasonArgs: '（管道）发送应答机制，创建临时服务等待超时。',
        detailArgs: '（管道）发送应答机制，创建临时服务等待超时。',
        adviceArgs: '',
    },
    3758161927: {
        descArgs: '（管道）等待事件失败。',
        reasonArgs: '（管道）等待事件失败。',
        detailArgs: '（管道）等待事件失败。',
        adviceArgs: '',
    },
    3758161928: {
        descArgs: '（管道）服务启动过程等待服务就绪过程超时。',
        reasonArgs: '（管道）服务启动过程等待服务就绪过程超时。',
        detailArgs: '（管道）服务启动过程等待服务就绪过程超时。',
        adviceArgs: '',
    },
    3758227457: {
        descArgs: 'USB Key已经被移除。',
        reasonArgs: 'USB Key已经被移除。',
        detailArgs: 'USB Key已经被移除。',
        adviceArgs: '',
    },
    3758227458: {
        descArgs: 'USB Key签名失败。',
        reasonArgs: 'USB Key签名失败。',
        detailArgs: 'USB Key签名失败。',
        adviceArgs: '',
    },
    3758227459: {
        descArgs: 'USB Key验证签名失败。',
        reasonArgs: 'USB Key验证签名失败。',
        detailArgs: 'USB Key验证签名失败。',
        adviceArgs: '',
    },
    3758227460: {
        descArgs: 'USBKEY设备是否插入或者驱动是否安装。',
        reasonArgs: 'USBKEY设备是否插入或者驱动是否安装。',
        detailArgs: 'USBKEY设备是否插入或者驱动是否安装。',
        adviceArgs: '',
    },
    3758227461: {
        descArgs: '不支持USBKEY设备类型。',
        reasonArgs: '不支持USBKEY设备类型。',
        detailArgs: '不支持USBKEY设备类型。',
        adviceArgs: '',
    },
    3758227462: {
        descArgs: '加载JITSSL库失败。',
        reasonArgs: '加载JITSSL库失败。',
        detailArgs: '加载JITSSL库失败。',
        adviceArgs: '',
    },
    3758227463: {
        descArgs: '加载USBKEY库函数失败。',
        reasonArgs: '加载USBKEY库函数失败。',
        detailArgs: '加载USBKEY库函数失败。',
        adviceArgs: '',
    },
    3758227464: {
        descArgs: '设置客户端证书失败。',
        reasonArgs: '设置客户端证书失败。',
        detailArgs: '设置客户端证书失败。',
        adviceArgs: '',
    },
    3758227465: {
        descArgs: '配置文件Config.ini中CertType配置项错误或缺失！',
        reasonArgs: '配置文件Config.ini中CertType配置项错误或缺失！',
        detailArgs: '配置文件Config.ini中CertType配置项错误或缺失！',
        adviceArgs: '',
    },
    3758227466: {
        descArgs: '配置文件Config.ini中UsePTGetPin配置项错误或缺失！',
        reasonArgs: '配置文件Config.ini中UsePTGetPin配置项错误或缺失！',
        detailArgs: '配置文件Config.ini中UsePTGetPin配置项错误或缺失！',
        adviceArgs: '',
    },
    3758227467: {
        descArgs: '获取服务端证书失败。',
        reasonArgs: '获取服务端证书失败。',
        detailArgs: '获取服务端证书失败。',
        adviceArgs: '',
    },
    3758227468: { descArgs: '证书已过期。', reasonArgs: '证书已过期。', detailArgs: '证书已过期。', adviceArgs: '' },
    3758227469: { descArgs: '证书已注销。', reasonArgs: '证书已注销。', detailArgs: '证书已注销。', adviceArgs: '' },
    3758227470: {
        descArgs: '证书无法识别。',
        reasonArgs: '证书无法识别。',
        detailArgs: '证书无法识别。',
        adviceArgs: '',
    },
    3758227471: {
        descArgs: '证书不是该机构颁发。',
        reasonArgs: '证书不是该机构颁发。',
        detailArgs: '证书不是该机构颁发。',
        adviceArgs: '',
    },
    3758227472: {
        descArgs: '认证失败，请检查证书有效性。',
        reasonArgs: '认证失败，请检查证书有效性。',
        detailArgs: '认证失败，请检查证书有效性。',
        adviceArgs: '',
    },
    3758227473: {
        descArgs: '获取服务端证书失败。',
        reasonArgs: '获取服务端证书失败。',
        detailArgs: '获取服务端证书失败。',
        adviceArgs: '',
    },
    3758227474: { descArgs: '证书已过期。', reasonArgs: '证书已过期。', detailArgs: '证书已过期。', adviceArgs: '' },
    3758227475: { descArgs: '证书已注销。', reasonArgs: '证书已注销。', detailArgs: '证书已注销。', adviceArgs: '' },
    3758227476: {
        descArgs: '证书无法识别。',
        reasonArgs: '证书无法识别。',
        detailArgs: '证书无法识别。',
        adviceArgs: '',
    },
    3758227477: {
        descArgs: '证书不是该机构颁发。',
        reasonArgs: '证书不是该机构颁发。',
        detailArgs: '证书不是该机构颁发。',
        adviceArgs: '',
    },
    3758227478: {
        descArgs: '认证失败，请检查证书有效性。',
        reasonArgs: '认证失败，请检查证书有效性。',
        detailArgs: '认证失败，请检查证书有效性。',
        adviceArgs: '',
    },
    3758227479: {
        descArgs: '加密通信上下文初始化失败。',
        reasonArgs: '加密通信上下文初始化失败。',
        detailArgs: '加密通信上下文初始化失败。',
        adviceArgs: '',
    },
    3758227480: {
        descArgs: '加密通信连接失败。',
        reasonArgs: '加密通信连接失败。',
        detailArgs: '加密通信连接失败。',
        adviceArgs: '',
    },
    3758227481: {
        descArgs: '加密通信没有初始化。',
        reasonArgs: '加密通信没有初始化。',
        detailArgs: '加密通信没有初始化。',
        adviceArgs: '',
    },
    3758292993: {
        descArgs: '通信连接的参数无效。',
        reasonArgs: '通信连接的参数无效。',
        detailArgs: '通信连接的参数无效。',
        adviceArgs: '',
    },
    3758292994: {
        descArgs: '通信连接的重复初始化。',
        reasonArgs: '通信连接的重复初始化。',
        detailArgs: '通信连接的重复初始化。',
        adviceArgs: '',
    },
    3758292995: {
        descArgs: '通信连接的没有初始化。',
        reasonArgs: '通信连接的没有初始化。',
        detailArgs: '通信连接的没有初始化。',
        adviceArgs: '',
    },
    3758292996: {
        descArgs: '通信连接失败。',
        reasonArgs: '通信连接失败。',
        detailArgs: '通信连接失败。',
        adviceArgs: '',
    },
    3758358529: {
        descArgs: '第三方身份认证失败。',
        reasonArgs: '第三方身份认证失败。',
        detailArgs: '第三方身份认证失败。',
        adviceArgs: '',
    },
    4026531841: {
        descArgs: '加载key驱动失败。',
        reasonArgs: '加载key驱动失败。',
        detailArgs: '加载key驱动失败。',
        adviceArgs: '',
    },
    4026531842: {
        descArgs: '初始化设备集合失败。',
        reasonArgs: '初始化设备集合失败。',
        detailArgs: '初始化设备集合失败。',
        adviceArgs: '',
    },
    4026531843: {
        descArgs: '初始化设备管理对象失败。',
        reasonArgs: '初始化设备管理对象失败。',
        detailArgs: '初始化设备管理对象失败。',
        adviceArgs: '',
    },
    4026531844: {
        descArgs: '连接设备失败。',
        reasonArgs: '连接设备失败。',
        detailArgs: '连接设备失败。',
        adviceArgs: '',
    },
    4026531845: {
        descArgs: '创建device失败。',
        reasonArgs: '创建device失败。',
        detailArgs: '创建device失败。',
        adviceArgs: '',
    },
    4026531846: {
        descArgs: '初始化应用对象失败。',
        reasonArgs: '初始化应用对象失败。',
        detailArgs: '初始化应用对象失败。',
        adviceArgs: '',
    },
    4026531847: {
        descArgs: '初始化哈希对象失败。',
        reasonArgs: '初始化哈希对象失败。',
        detailArgs: '初始化哈希对象失败。',
        adviceArgs: '',
    },
    4026531848: {
        descArgs: '初始化容器对象失败。',
        reasonArgs: '初始化容器对象失败。',
        detailArgs: '初始化容器对象失败。',
        adviceArgs: '',
    },
    4026531849: { descArgs: '验证PIN失败。', reasonArgs: '验证PIN失败。', detailArgs: '验证PIN失败。', adviceArgs: '' },
    4026531850: {
        descArgs: '打开容器失败。',
        reasonArgs: '打开容器失败。',
        detailArgs: '打开容器失败。',
        adviceArgs: '',
    },
    4026531851: { descArgs: '产生P10失败。', reasonArgs: '产生P10失败。', detailArgs: '产生P10失败。', adviceArgs: '' },
    4026531852: {
        descArgs: '创建容器失败。',
        reasonArgs: '创建容器失败。',
        detailArgs: '创建容器失败。',
        adviceArgs: '',
    },
    4026531853: {
        descArgs: '没有发现设备。',
        reasonArgs: '没有发现设备。',
        detailArgs: '没有发现设备。',
        adviceArgs: '',
    },
    4026531854: {
        descArgs: '应用名称不能为空。',
        reasonArgs: '应用名称不能为空。',
        detailArgs: '应用名称不能为空。',
        adviceArgs: '',
    },
    4026531855: {
        descArgs: '删除容器失败。',
        reasonArgs: '删除容器失败。',
        detailArgs: '删除容器失败。',
        adviceArgs: '',
    },
    4026531856: { descArgs: '没发现证书。', reasonArgs: '没发现证书。', detailArgs: '没发现证书。', adviceArgs: '' },
    4026531857: {
        descArgs: '安装签名证书失败。',
        reasonArgs: '安装签名证书失败。',
        detailArgs: '安装签名证书失败。',
        adviceArgs: '',
    },
    4026531858: {
        descArgs: '安装加密证书失败。',
        reasonArgs: '安装加密证书失败。',
        detailArgs: '安装加密证书失败。',
        adviceArgs: '',
    },
    4026531859: {
        descArgs: '指定的容器不存在。',
        reasonArgs: '指定的容器不存在。',
        detailArgs: '指定的容器不存在。',
        adviceArgs: '',
    },
    4026531860: {
        descArgs: '设备认证失败。',
        reasonArgs: '设备认证失败。',
        detailArgs: '设备认证失败。',
        adviceArgs: '',
    },
    4026531861: {
        descArgs: '创建应用失败。',
        reasonArgs: '创建应用失败。',
        detailArgs: '创建应用失败。',
        adviceArgs: '',
    },
    4026531863: {
        descArgs: '设备名称为空。',
        reasonArgs: '设备名称为空。',
        detailArgs: '设备名称为空。',
        adviceArgs: '',
    },
    4026531864: {
        descArgs: '未能识别的算法。',
        reasonArgs: '未能识别的算法。',
        detailArgs: '未能识别的算法。',
        adviceArgs: '',
    },
    4026531865: {
        descArgs: '设备空间不足。',
        reasonArgs: '设备空间不足。',
        detailArgs: '设备空间不足。',
        adviceArgs: '',
    },
    4026531866: { descArgs: '参数错误。', reasonArgs: '参数错误。', detailArgs: '参数错误。', adviceArgs: '' },
    4026531867: {
        descArgs: '未匹配到指定的设备。',
        reasonArgs: '未匹配到指定的设备。',
        detailArgs: '未匹配到指定的设备。',
        adviceArgs: '',
    },
    4026531868: {
        descArgs: '打开应用失败。',
        reasonArgs: '打开应用失败。',
        detailArgs: '打开应用失败。',
        adviceArgs: '',
    },
    4026531869: { descArgs: 'p7签名失败。', reasonArgs: 'p7签名失败。', detailArgs: 'p7签名失败。', adviceArgs: '' },
    4026531870: {
        descArgs: '枚举应用失败。',
        reasonArgs: '枚举应用失败。',
        detailArgs: '枚举应用失败。',
        adviceArgs: '',
    },
    4026532097: {
        descArgs: 'Socket已连接。',
        reasonArgs: 'Socket已连接。',
        detailArgs: 'Socket已连接。',
        adviceArgs: '请不要重复连接。',
    },
    4026532098: {
        descArgs: 'Socket打开失败。',
        reasonArgs: 'Socket打开失败。',
        detailArgs: 'Socket打开失败。',
        adviceArgs: '请检查网络。',
    },
    4026532099: {
        descArgs: 'Socket服务端发生错误。',
        reasonArgs: 'Socket服务端发生错误。',
        detailArgs: 'Socket服务端发生错误。',
        adviceArgs: '请稍候重试。',
    },
};
export { usbKeyErrZh };



// WEBPACK FOOTER //
// ./public/base/utils/i18n/zh_CN/exception.js